module.exports = __webpack_public_path__ + "static/media/YB5F14_2.36c213d5.jpg";